import * as React from 'react';
import cx from 'classnames';

interface WarningProps {
    children: React.ReactNode;
    className?: string;
}

export function Warning({ children, className }: WarningProps) {
    return (
        <p className={cx('text-warning', className)}>
            <span className="icon icon-warning" /> {children}
        </p>
    );
}

export default Warning;
